import { reducer as dayClose } from "./day-close/slice";

export const reducer = {
  dayClose,
};
